require('./comments.component');
require('./comment-entry.component');
require('./comment-like.component');
